import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./context/LanguageContext";
import PageTranslator from "./components/PageTranslator";
import { AdFloatingBottomBar } from "./components/AdSense";
import ExitIntentPrompt from "./components/ExitIntentPrompt";
import HomePage from "./pages/HomePage";
import PercentageCalculatorPage from "./pages/PercentageCalculatorPage";
import SitemapPage from "./pages/SitemapPage";
import CategoryPage from "./pages/CategoryPage";
import BMICalculatorPage from "./pages/BMICalculatorPage";
import LoanCalculatorPage from "./pages/LoanCalculatorPage";
import AgeCalculatorPage from "./pages/AgeCalculatorPage";
import MortgageCalculatorPage from "./pages/MortgageCalculatorPage";
import CalorieCalculatorPage from "./pages/CalorieCalculatorPage";
import GPACalculatorPage from "./pages/GPACalculatorPage";
import AutoLoanCalculatorPage from "./pages/AutoLoanCalculatorPage";
import InterestCalculatorPage from "./pages/InterestCalculatorPage";
import PaymentCalculatorPage from "./pages/PaymentCalculatorPage";
import RetirementCalculatorPage from "./pages/RetirementCalculatorPage";
import AmortizationCalculatorPage from "./pages/AmortizationCalculatorPage";
import InvestmentCalculatorPage from "./pages/InvestmentCalculatorPage";
import InflationCalculatorPage from "./pages/InflationCalculatorPage";
import FinanceCalculatorPage from "./pages/FinanceCalculatorPage";
import IncomeTaxCalculatorPage from "./pages/IncomeTaxCalculatorPage";
import CompoundInterestCalculatorPage from "./pages/CompoundInterestCalculatorPage";
import SalaryCalculatorPage from "./pages/SalaryCalculatorPage";
import InterestRateCalculatorPage from "./pages/InterestRateCalculatorPage";
import SalesTaxCalculatorPage from "./pages/SalesTaxCalculatorPage";
import FractionCalculatorPage from "./pages/FractionCalculatorPage";
import RandomNumberGeneratorPage from "./pages/RandomNumberGeneratorPage";
import TriangleCalculatorPage from "./pages/TriangleCalculatorPage";
import StandardDeviationCalculatorPage from "./pages/StandardDeviationCalculatorPage";
import BodyFatCalculatorPage from "./pages/BodyFatCalculatorPage";
import BMRCalculatorPage from "./pages/BMRCalculatorPage";
import IdealWeightCalculatorPage from "./pages/IdealWeightCalculatorPage";
import PaceCalculatorPage from "./pages/PaceCalculatorPage";
import PregnancyCalculatorPage from "./pages/PregnancyCalculatorPage";
import PregnancyConceptionCalculatorPage from "./pages/PregnancyConceptionCalculatorPage";
import DueDateCalculatorPage from "./pages/DueDateCalculatorPage";
import DateCalculatorPage from "./pages/DateCalculatorPage";
import TimeCalculatorPage from "./pages/TimeCalculatorPage";
import HoursCalculatorPage from "./pages/HoursCalculatorPage";
import GradeCalculatorPage from "./pages/GradeCalculatorPage";
import ConcreteCalculatorPage from "./pages/ConcreteCalculatorPage";
import SubnetCalculatorPage from "./pages/SubnetCalculatorPage";
import PasswordGeneratorPage from "./pages/PasswordGeneratorPage";
import ConversionCalculatorPage from "./pages/ConversionCalculatorPage";
import ScientificCalculatorPage from "./pages/ScientificCalculatorPage";
import AboutPage from "./pages/AboutPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import ContactPage from "./pages/ContactPage";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <AdFloatingBottomBar />
            <ExitIntentPrompt />
            <PageTranslator>
              <Routes>
                <Route path="/" element={<PercentageCalculatorPage />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/percentage-calculator" element={<PercentageCalculatorPage />} />
          <Route path="/sitemap" element={<SitemapPage />} />
          <Route path="/bmi-calculator" element={<BMICalculatorPage />} />
          <Route path="/loan-calculator" element={<LoanCalculatorPage />} />
          <Route path="/age-calculator" element={<AgeCalculatorPage />} />
          <Route path="/mortgage-calculator" element={<MortgageCalculatorPage />} />
          <Route path="/calorie-calculator" element={<CalorieCalculatorPage />} />
          <Route path="/gpa-calculator" element={<GPACalculatorPage />} />
          <Route path="/auto-loan-calculator" element={<AutoLoanCalculatorPage />} />
          <Route path="/interest-calculator" element={<InterestCalculatorPage />} />
          <Route path="/payment-calculator" element={<PaymentCalculatorPage />} />
          <Route path="/retirement-calculator" element={<RetirementCalculatorPage />} />
          <Route path="/amortization-calculator" element={<AmortizationCalculatorPage />} />
          <Route path="/investment-calculator" element={<InvestmentCalculatorPage />} />
          <Route path="/inflation-calculator" element={<InflationCalculatorPage />} />
          <Route path="/finance-calculator" element={<FinanceCalculatorPage />} />
          <Route path="/income-tax-calculator" element={<IncomeTaxCalculatorPage />} />
          <Route path="/compound-interest-calculator" element={<CompoundInterestCalculatorPage />} />
          <Route path="/salary-calculator" element={<SalaryCalculatorPage />} />
          <Route path="/interest-rate-calculator" element={<InterestRateCalculatorPage />} />
          <Route path="/sales-tax-calculator" element={<SalesTaxCalculatorPage />} />
          <Route path="/fraction-calculator" element={<FractionCalculatorPage />} />
          <Route path="/random-number-generator" element={<RandomNumberGeneratorPage />} />
          <Route path="/triangle-calculator" element={<TriangleCalculatorPage />} />
          <Route path="/standard-deviation-calculator" element={<StandardDeviationCalculatorPage />} />
          <Route path="/body-fat-calculator" element={<BodyFatCalculatorPage />} />
          <Route path="/bmr-calculator" element={<BMRCalculatorPage />} />
          <Route path="/ideal-weight-calculator" element={<IdealWeightCalculatorPage />} />
          <Route path="/pace-calculator" element={<PaceCalculatorPage />} />
          <Route path="/pregnancy-calculator" element={<PregnancyCalculatorPage />} />
          <Route path="/pregnancy-conception-calculator" element={<PregnancyConceptionCalculatorPage />} />
          <Route path="/due-date-calculator" element={<DueDateCalculatorPage />} />
          <Route path="/date-calculator" element={<DateCalculatorPage />} />
          <Route path="/time-calculator" element={<TimeCalculatorPage />} />
          <Route path="/hours-calculator" element={<HoursCalculatorPage />} />
          <Route path="/grade-calculator" element={<GradeCalculatorPage />} />
          <Route path="/concrete-calculator" element={<ConcreteCalculatorPage />} />
          <Route path="/subnet-calculator" element={<SubnetCalculatorPage />} />
          <Route path="/password-generator" element={<PasswordGeneratorPage />} />
          <Route path="/conversion-calculator" element={<ConversionCalculatorPage />} />
          <Route path="/scientific-calculator" element={<ScientificCalculatorPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/:category" element={<CategoryPage />} />
              </Routes>
            </PageTranslator>
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
